import { IInfrastructureProjectObject, InfrastructureProjectType } from '../types/project.types';
import { api } from './api';

const baseUrl = '/public/infrastructure';

export const getInfrastructureProjects = (kato: string, type: InfrastructureProjectType) => {
  return api.get(`${baseUrl}/list?kato=${kato}&type=${type}`).then(res => res.data.list);
}

export const getInfrastructureProjectById = (type: InfrastructureProjectType, id: number): Promise<IInfrastructureProjectObject> => {
  return api.get(`${baseUrl}/${id}?type=${type}`).then(res => res.data.data);
}